import { render, staticRenderFns } from "./sendsform.vue?vue&type=template&id=3d47f947&scoped=true&"
import script from "./sendsform.vue?vue&type=script&lang=js&"
export * from "./sendsform.vue?vue&type=script&lang=js&"
import style0 from "./sendsform.vue?vue&type=style&index=0&id=3d47f947&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d47f947",
  null
  
)

export default component.exports